import script from "./ShapePool.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShapePool.vue?vue&type=script&lang=ts&setup=true"

import "./ShapePool.vue?vue&type=style&index=0&id=8b994b42&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b994b42"]])

export default __exports__